import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ActivityFormEffects } from './activity-form.effects';

@NgModule({
  imports: [EffectsModule.forFeature([ActivityFormEffects])]
})
export class ActivityFormLazyModule {}
